import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Font } from 'components'
import cx from 'classnames'
import styles from './styles.module.scss'

const Footer = ({ alightCenter, hidePrivacy, hideTerms, hideRules }) => {
  return (
    <div
      className={cx(styles.container, { [styles.alightCenter]: alightCenter })}
    >
      <Font className={styles.caption} type="caption">
        © {new Date().getUTCFullYear()} Recon, Inc. All rights reserved
      </Font>
      {!hidePrivacy && (
        <Font className={cx(styles.caption, 'ml-16')} type="caption">
          <Link to="/privacy">Privacy</Link>
        </Font>
      )}
      {!hideTerms && (
        <Font className={cx(styles.caption, 'ml-16')} type="caption">
          <Link to="/terms">Terms</Link>
        </Font>
      )}
      {!hideRules && (
        <Font className={cx(styles.caption, 'ml-16')} type="caption">
          <Link to="/sweepstakes">Sweepstakes rules</Link>
        </Font>
      )}
    </div>
  )
}

Footer.propTypes = {
  alightCenter: PropTypes.bool,
  hidePrivacy: PropTypes.bool,
  hideTerms: PropTypes.bool,
  hideRules: PropTypes.bool,
}

Footer.defaultTypes = {
  alightCenter: false,
  hidePrivacy: false,
  hideTerms: false,
  hideRules: false,
}

export default Footer
